import axios from 'axios';
import moment from 'moment/moment';

import { ROOT_URL_V2, getCSRFToken } from '../config';
import { TMeta, TSeries } from '../types';


export const LOAD_SERIES = 'LOAD_SERIES';
export const LOAD_SERIES_SUCCESS = 'LOAD_SERIES_SUCCESS';
export const LOAD_SERIES_FAILURE = 'LOAD_SERIES_FAILURE';
export const SET_SELECTED_SERIES = 'SET_SELECTED_SERIES';

type TloadSeries = {
    type: typeof LOAD_SERIES,
}

type TloadSeriesSuccess = {
    type: typeof LOAD_SERIES_SUCCESS,
    payload: {
        content: TSeries[],
        meta: TMeta,
    },
}

type TloadSeriesFailure = {
    type: typeof LOAD_SERIES_FAILURE,
    payload: {
        content: TSeries[],
        meta: TMeta,
    };
}

type TsetSelectedSeries = {
    type: typeof SET_SELECTED_SERIES,
    selectedSeries: TSeries,
}

export type TSeriesActions =
    | TloadSeries
    | TloadSeriesSuccess
    | TloadSeriesFailure
    | TsetSelectedSeries

export const loadSeries = () => ({
    type: LOAD_SERIES,
});

export const loadSeriesSuccess = (data: TSeries[]) => ({
    type: LOAD_SERIES_SUCCESS,
    payload: data,
});

export const loadSeriesFailure = (error: unknown) => ({
    type: LOAD_SERIES_FAILURE,
    payload: error,
});

export const setSelectedSeries = (data: TSeries) => ({
    type: SET_SELECTED_SERIES,
    selectedSeries: data,
});

export function fetchSeries(searchParams: URLSearchParams) {
    return async(dispatch: any) => {
        dispatch(loadSeries());
        let seriesResult;

        // Fetch only today results if no before/after/get all parameters are given
        if (!searchParams.get('before') && !searchParams.get('after') && !searchParams.get('getall')) {
            searchParams.append('after', moment().startOf('day').toISOString());
            searchParams.append('before', moment().endOf('day').toISOString());
        }

        try {
            const response = await axios({
                method: 'GET',
                url: `${ROOT_URL_V2}series/?${searchParams.toString()}`,
                headers: {
                    'X-CSRFToken': getCSRFToken(),
                },
            });
            seriesResult = response.data;
        } catch (error) {
            dispatch(loadSeriesFailure(error));
            return;
        }
        dispatch(loadSeriesSuccess(seriesResult));
    };
}
